import { ComponentRecognizer } from '../../ComponentRecognizer/ComponentRecognizer';
import type { FooterBlockImageType } from '../types';

type BlockImageProps = {
  data: FooterBlockImageType;
};

export const BlockImage = ({ data }: BlockImageProps) => (
  <div
    className="[&>.dangerously-html_a]:text-color-footer-contrasttext! [&>.dangerously-html]:inline-flex [&>.dangerously-html]:w-auto [&>.dangerously-html]:shrink-0 [&>.dangerously-html]:content-center [&>.dangerously-html]:align-top"
    key={`block-image-${data.id}`}
  >
    {data.paragraph?.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ComponentRecognizer key={index} item={item} />
    ))}
  </div>
);
